import { render, staticRenderFns } from "./SetBossModal.vue?vue&type=template&id=68b64713&scoped=true&"
import script from "./SetBossModal.vue?vue&type=script&lang=js&"
export * from "./SetBossModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b64713",
  null
  
)

export default component.exports